<div mat-dialog-content class="dialog-tarefa-coluna__conteudo">
  <p>{{ titulo }}</p>
  <div class="dialog-tarefa-coluna__cores">
    <button *ngFor="let cor of cores" type="button" [style.background]="cor" [class.dialog-tarefa-coluna__cor--ativa]="noCor === cor"
      [attr.aria-label]="'Selecionar a cor ' + cor" (click)="selecionarCor(cor)"><mat-icon *ngIf="noCor === cor">check</mat-icon></button>
    <button type="button" class="dialog-tarefa-coluna__cor-personalizada" [matMenuTriggerFor]="menuCor"
      [class.dialog-tarefa-coluna__cor--ativa]="!cores.includes(noCor)" [attr.aria-label]="'Selecionar ' + titulo.toLowerCase() + ' personalizada'">
      <mat-icon>palette</mat-icon>
    </button>
  </div>
  <div class="dialog-tarefa-coluna__previsualizacao"><span [style.background]="noCor"></span><strong>{{ noCor }}</strong></div>
</div>

<mat-menu #menuCor="matMenu">
  <ng-template matMenuContent>
    <color-picker (click)="$event.stopPropagation()" [(value)]="noCor" [(format)]="formatoCor"
      [hideAlpha]="true"></color-picker>
  </ng-template>
</mat-menu>

<div mat-dialog-actions class="dialog-tarefa-coluna__acoes" align="end">
  <button mat-button color="warn" type="button" (click)="removerCor()">Remover cor</button>
  <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" type="button" (click)="salvar()">Salvar</button>
</div>
